import React, { useState, useEffect } from 'react';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import OrderDetails from '../Order/OrderDetail';
import OrderHistory from '../Order/OrderHistory';
import Helper from 'src/helper/Helper';

export function Order() {
    const [selectedTab, setSelectedTab] = useState('')
    const OrderType = System.getParams().page

    const { OrderPages } = Constants

    useEffect(() => {
        setSelectedTab(OrderType ? OrderType : OrderPages.OrderHistory.param_value);
    }, [OrderType])

    useEffect(() => {
        Helper.feedBackButtonScript()
       }, []);
    return (

        <div className="logged-screen">
            {selectedTab === OrderPages.OrderDetail.param_value && <OrderDetails />}
            {selectedTab === OrderPages.OrderHistory.param_value && <OrderHistory />}
        </div>
    );
}